<template>
  <div class="conract-page py-4">
    <div class="container">
      <div class="w-full main-card px-3 md:px-4 lg:px-5 py-10">
        <div class="w-full">
          <h2 class="text-center">Program Planner</h2>
        </div>

        <div class="w-full mt-8 metrics_data-tabs">
          <iframe
            :src="`https://dev.commuter.commutrics.com/free-transit-program/${this.user.id}`"
            title="commuter"
            frameborder="0"
            class="w-full"
            style="height: 800px;"
          >
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    user() {
      return this.$store.state.auth.user || null;
    },
  },
};
</script>

<style scoped>
.metrics_data-tabs iframe {
  width: 100%;
}
</style>
